import {
  Grid,
  Typography,
  TextField,
  Button,
  Box,
  CircularProgress,
  Autocomplete,
  MenuItem,
} from "@mui/material";
import { useState, useEffect } from "react";
import AssignmentIcon from "@mui/icons-material/Assignment";
import { getLawyers } from "../../services/LawyerService";
import { uploadFile } from "../../services/LawsuitService";
import CardHeader from "../General/CardHeader";
import FileUploadBox from "../General/FileUploadBox";
import GlassCard from "../General/GlassCard";
import { useToast } from "../../context/ToastContext";

export default function UploadLawsuit() {
  const { showToast } = useToast();
  const [loading, setLoading] = useState(false);

  const [lawyers, setLawyers] = useState([]);
  const [selectedLawyer, setSelectedLawyer] = useState(null);
  const [errors, setErrors] = useState({});
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploadType, setUploadType] = useState("lawsuit"); // 'lawsuit' | 'fine'

  const fetchLawyers = async () => {
    setLoading(true);
    try {
      const res = await getLawyers();
      setLawyers(res?.data?.data || []);
    } catch {
      showToast("Error al cargar los abogados.", "error")
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLawyers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleFileSelect = (file) => {
    if (file) {
      const validExtensions = ["zip"];
      const fileExtension = file.name.split(".").pop().toLowerCase();
      if (!validExtensions.includes(fileExtension)) {
        setErrors({
          ...errors,
          lawsuitFile: "Solo se permiten archivos .zip",
        });
        setSelectedFile(null);
        return;
      }
      setErrors({ ...errors, lawsuitFile: "" });
      setSelectedFile(file);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();    setErrors({});
    setLoading(true);

    if (!uploadType) {
      showToast("Debe seleccionar el tipo de carga.", "info")
      setLoading(false);
      return;
    }

    if (!selectedLawyer) {
      showToast("Debe seleccionar un abogado.", "info")
      setLoading(false);
      return;
    }

    if (!selectedFile) {
      showToast("Debe seleccionar un archivo.", "info")
      setLoading(false);
      return;
    }

    const formData = new FormData();
    formData.append("file", selectedFile);
    formData.append("lawyer_id", selectedLawyer.id);
    formData.append("type_upload", uploadType);

    try {
      const response = await uploadFile(formData);

      showToast(response.data.message, "success")
      setSelectedFile(null);
      setErrors({});
    } catch (error) {
      if (error.response?.status === 422 || error.response?.status === 404) {
        showToast(error.response.data?.message || "Ocurrió un error.", "error")
      } else {
        console.log(error);
        showToast("Ocurrió un error inesperado.", "error")
      }
    } finally {
      setLoading(false);
    }
  };

  const title =
    uploadType === "fine"
      ? "Cargar Multas (ZIP)"
      : "Cargar Títulos Electrónicos (ZIP)";

  const buttonText =
    uploadType === "fine" ? "Cargar Multas" : "Cargar Títulos";

  return (
    <Grid container justifyContent="center" sx={{ mt: 4 }}>
      <Grid size={{ xs: 12, sm: 12, md: 12, lg: 10 }}>

        <GlassCard>
          <CardHeader icon={<AssignmentIcon />} title={title} description="Cargar archivos ZIP de títulos o multas" />

          <Box component="form" onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              <Grid size={{ xs: 12 }}>
                <TextField
                  select
                  label="Tipo de carga"
                  value={uploadType}
                  onChange={(e) => setUploadType(e.target.value)}
                  fullWidth
                >
                  <MenuItem value="lawsuit">
                    TÍTULOS (AUT | INM | CI | TA)
                  </MenuItem>
                  <MenuItem value="fine">MULTAS</MenuItem>
                </TextField>

                <Box sx={{ mt: 2 }}>
                  <Autocomplete
                    options={lawyers}
                    getOptionLabel={(option) =>
                      `${option.name} ${option.lastname}` || ""
                    }
                    value={selectedLawyer}
                    onChange={(event, newValue) => setSelectedLawyer(newValue)}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Abogado"
                        placeholder="Seleccionar..."
                      />
                    )}
                  />
                </Box>

                <Box sx={{ mt: 3 }}>
                  <FileUploadBox
                    selectedFile={selectedFile}
                    onFileSelect={handleFileSelect}
                    accept=".zip"
                    placeholder="Seleccionar Archivo ZIP"
                    helperText="O arrastrá el archivo ZIP aquí"
                  />
                  {errors.lawsuitFile && (
                    <Typography
                      color="error"
                      variant="caption"
                      sx={{ mt: 1, display: "block" }}
                    >
                      {errors.lawsuitFile}
                    </Typography>
                  )}
                </Box>
              </Grid>

              <Grid size={{ xs: 12 }}>
                <Button
                  variant="contained"
                  color="primary"
                  type="submit"
                  fullWidth
                  disabled={loading}
                  sx={{ mt: 1 }}
                >
                  {loading ? (
                    <CircularProgress size={24} color="inherit" />
                  ) : (
                    buttonText
                  )}
                </Button>
              </Grid>
            </Grid>
          </Box>
        </GlassCard>
      </Grid>
    </Grid>
  );
}
